import React from 'react'
import { Link } from 'react-router-dom'
import { useStoreView } from 'hooks/useStoreView'
import { ReactComponent as LogoSvg } from 'resources/svg/logo.svg'
import LogoLivBrite from 'app/livbrite/resources/images/livBrite_logo.png'
import { Actions } from '../Actions'
import { SmallMenu } from '../SmallMenu'
import { Wrapper, Logo } from './components/Styled'
import { PromotionalBanner } from 'components/PromotionalBanner'
import { FlexWrapper } from 'lib/ui'

export const MobileVersion = () => {
  const { isSofiaAndGrace } = useStoreView()

  return (
    <Wrapper isSofiaAndGrace={isSofiaAndGrace}>
      <FlexWrapper kind='between' verticalCenter className='wrapper'>
        <SmallMenu />
        <Logo>
          <Link to='/'>
            {isSofiaAndGrace ? (
              <LogoSvg />
            ) : (
              <img src={LogoLivBrite} alt='LivBrite' />
            )}
          </Link>
        </Logo>
        <Actions />
      </FlexWrapper>
      <PromotionalBanner />
    </Wrapper>
  )
}
